import ComodantStep from "./steps/ComodantStep";
import ComodatarStep from "./steps/ComodatarStep";
import ImobilStep from "../inchiriere/steps/ImobilStep";
import DurataStep from "./steps/DurataStep";
import ConditiiStep from "./steps/ConditiiStep";
import PVSetupStep from "../inchiriere/steps/PVSetupStep";
import PVRoomsStep from "../inchiriere/steps/PVRoomsStep";
import PVUtilitiesStep from "../inchiriere/steps/PVUtilitiesStep";
import PreviewStep from "./steps/PreviewStep";
import buildComodatPDF from "./buildPDF";
import buildComodatPVPDF from "./buildPVPDF";

const comodatConfig = {
  buildPDF: buildComodatPDF,
  buildPVPDF: buildComodatPVPDF,
  title: "Contract de Comodat Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract de comodat (folosinta gratuita) conform legislatiei din Romania",
  step1Benefit: "Model complet de folosință gratuită, conform Codului Civil",
  pdfFilename: "contract-comodat.pdf",
  steps: [
    { id: "comodant", label: "Comodant", title: "Datele Comodantului", icon: "\uD83C\uDFE0", component: ComodantStep },
    { id: "comodatar", label: "Comodatar", title: "Datele Comodatarului", icon: "\uD83D\uDC64", component: ComodatarStep },
    { id: "imobil", label: "Imobil", title: "Datele Imobilului", icon: "\uD83C\uDFE2", component: ImobilStep },
    { id: "durata", label: "Durata", title: "Durata Contractului", icon: "\uD83D\uDCC5", component: DurataStep },
    { id: "conditii", label: "Conditii", title: "Conditii Contractuale", icon: "\uD83D\uDCCB", component: ConditiiStep },
    { id: "pvSetup", label: "PV Setup", title: "Proces Verbal — Configurare", icon: "\uD83D\uDCDD", component: PVSetupStep },
    { id: "pvRooms", label: "Inventar", title: "Proces Verbal — Inventar Camere", icon: "\uD83D\uDECB\uFE0F", component: PVRoomsStep, visible: (data) => !!data.pvEnabled },
    { id: "pvUtilities", label: "Contoare", title: "Proces Verbal — Citiri Contoare", icon: "\uD83D\uDD0C", component: PVUtilitiesStep, visible: (data) => !!data.pvEnabled },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "\uD83D\uDCC4", component: PreviewStep },
  ],
  defaultData: {
    comodantPJ: false,
    comodantNume: "",
    comodantCNP: "",
    comodantCI: "",
    comodantAdresa: "",
    comodantFirma: "",
    comodantCUI: "",
    comodantRegCom: "",
    comodantSediu: "",
    comodantReprezentant: "",
    comodatarPJ: false,
    comodatarNume: "",
    comodatarCNP: "",
    comodatarCI: "",
    comodatarAdresa: "",
    comodatarFirma: "",
    comodatarCUI: "",
    comodatarRegCom: "",
    comodatarSediu: "",
    comodatarReprezentant: "",
    imobilTip: "apartament",
    imobilTipAltul: "",
    imobilAdresa: "",
    imobilSuprafata: "",
    imobilCamere: "",
    imobilEtaj: "",
    mobilat: true,
    dataInceput: "",
    durata: "12",
    notificareZile: "30",
    utilitatiComodatar: true,
    animalePermise: false,
    fumatPermis: false,
    subcomodarePermisa: false,
    nrMaxPersoane: "2",
    // PV fields
    pvEnabled: false,
    pvDate: "",
    pvStareGenerala: "buna",
    pvRooms: [],
    pvUtilities: {},
    pvObservatiiGenerale: "",
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "comodant") {
      if (data.comodantPJ) {
        if (!data.comodantFirma.trim() || data.comodantFirma.trim().length < 2) {
          errors.comodantFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.comodantCUI.trim()) {
          errors.comodantCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.comodantCUI.trim())) {
          errors.comodantCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.comodantSediu.trim()) errors.comodantSediu = "Sediul social este obligatoriu";
        if (!data.comodantReprezentant.trim()) {
          errors.comodantReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.comodantReprezentant.trim().split(/\s+/).length < 2) {
          errors.comodantReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.comodantNume.trim()) {
          errors.comodantNume = "Numele este obligatoriu";
        } else if (data.comodantNume.trim().split(/\s+/).length < 2) {
          errors.comodantNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.comodantCNP.trim() && !/^\d{13}$/.test(data.comodantCNP.trim())) {
          errors.comodantCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.comodantCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.comodantCI.trim())) {
          errors.comodantCI = "Format invalid (ex: RD 123456 sau RD 1234567)";
        }
        if (!data.comodantAdresa.trim()) errors.comodantAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "comodatar") {
      if (data.comodatarPJ) {
        if (!data.comodatarFirma.trim() || data.comodatarFirma.trim().length < 2) {
          errors.comodatarFirma = "Denumirea societatii este obligatorie (min. 2 caractere)";
        }
        if (!data.comodatarCUI.trim()) {
          errors.comodatarCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.comodatarCUI.trim())) {
          errors.comodatarCUI = "Format invalid (ex: RO12345678 sau 12345678)";
        }
        if (!data.comodatarSediu.trim()) errors.comodatarSediu = "Sediul social este obligatoriu";
        if (!data.comodatarReprezentant.trim()) {
          errors.comodatarReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.comodatarReprezentant.trim().split(/\s+/).length < 2) {
          errors.comodatarReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      } else {
        if (!data.comodatarNume.trim()) {
          errors.comodatarNume = "Numele este obligatoriu";
        } else if (data.comodatarNume.trim().split(/\s+/).length < 2) {
          errors.comodatarNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.comodatarCNP.trim() && !/^\d{13}$/.test(data.comodatarCNP.trim())) {
          errors.comodatarCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.comodatarCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.comodatarCI.trim())) {
          errors.comodatarCI = "Format invalid (ex: MZ 654321 sau MZ 6543210)";
        }
        if (!data.comodatarAdresa.trim()) errors.comodatarAdresa = "Adresa este obligatorie";
      }
    }

    if (stepId === "imobil") {
      if (data.imobilTip === "altul" && (!data.imobilTipAltul || !data.imobilTipAltul.trim())) {
        errors.imobilTipAltul = "Specificati tipul imobilului";
      }
      if (data.imobilTip === "apartament" && !data.imobilCamere) {
        errors.imobilCamere = "Selecteaza numarul de camere";
      }
      if (!data.imobilAdresa.trim()) errors.imobilAdresa = "Adresa imobilului este obligatorie";
      if (!data.imobilSuprafata) {
        errors.imobilSuprafata = "Suprafata este obligatorie";
      } else if (Number(data.imobilSuprafata) <= 0) {
        errors.imobilSuprafata = "Suprafata trebuie sa fie un numar pozitiv";
      }
    }

    if (stepId === "durata") {
      if (!data.dataInceput) errors.dataInceput = "Data de inceput este obligatorie";
    }

    return errors;
  },
};

export default comodatConfig;
